import React, { useEffect, useState } from 'react'
import {
  Box,
  Button,
  Container,
  Dialog,
  DialogContent,
  Divider,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  TextField,
  Typography,
} from '@mui/material'
import FlagColombiaIcon from 'src/assets/images/icons/flag-colombia-icon.png'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faClock,
  faDollarSign,
  faDownload,
  faIdCard,
  faKey,
  faMailBulk,
  faPhone,
  faUnlock,
  faUser,
} from '@fortawesome/free-solid-svg-icons'
import BoxWithShadow from 'src/components/BoxWithShadow'
import useUserkeypago from 'src/hooks/Onboarding/user/useUserkeypago'
import { format } from 'date-fns'
import { formatToCOP } from 'src/utils/utils'
import { Link, useNavigate } from 'react-router-dom'
import useTestModels from 'src/hooks/Onboarding/testModels/useTestModels'
import useIsMounted from 'src/hooks/useIsMounted'
import ModalImage from './Components/ModalImage'
import "./ClientSheet.scss"
import { useDispatch } from 'react-redux'
import { changeKpUser } from 'src/redux/Onboarding/user/kpUserSlice'
import useLoading from 'src/hooks/useLoading'

const BoxPicture = ({
  children,
  sx,

  //add events here
}: {
  children: React.ReactNode
  sx?: React.CSSProperties
  //add events here
}) => {
  return (
    <Box
      //add events here

      sx={{
        display: 'flex',
        bgcolor: 'background.paper',
        minWidth: 250,
        borderRadius: 1,
        border: 1,
        borderColor: 'green',
        p: 1,
        alignItems: 'center',
        maxWidth: 250,
        position: 'relative',
        gap: 2,
        cursor: 'pointer',
        transition: 'all 0.3s',
        ':hover': {
          borderColor: 'primary.main',
          backgroundColor: 'rgba(0,0,0,0.1)',
          color: 'primary.main',
        },
        ...sx,
      }}
    >
      {children}
    </Box>
  )
}

const ClientSheet = () => {
  const { getUserInfo, kpUser, downloadDocument, currentOnboardings } = useUserkeypago();
  const navigate = useNavigate()
  const [previewImg, setPreviewImg] = useState<string | null>(null)
  const [filters, setFilters] = useState({
    userDocId: '',
    country: 'CO',
    userDocType: 'CC',
    key: localStorage.getItem('filterKey') || 'cc',
    onboardingId: "",
    selectedOnboarding: "default",
  })
  const [openModal, setOpenModal] = useState(false)
  const { startLoading, stopLoading } = useLoading()
  const dispatch = useDispatch()
  const [selectedImage, setSelectedImage] = useState<string | null>(null)
  const handleImageClick = (imagePath: string) => {
    setSelectedImage(imagePath)
    setOpenModal(true)
  }

  const handleCloseModal = () => {
    setOpenModal(false)
    setSelectedImage(null)
  }

  const onSelectOnBoardingSchedule = (onboarding: any) => {
    dispatch(changeKpUser({
      ...kpUser,
      ...onboarding
    }))
  }

  const onPreviewImg = (imagePath: string) => {
    setPreviewImg(imagePath)
  }

  useEffect(() => {
    if (currentOnboardings && currentOnboardings.length) {
      setFilters({
        ...filters,
        selectedOnboarding: kpUser?.onboardingInfo.onboardingId || "default",
      })
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentOnboardings])

  return (
    <Container>
      <div style={{ display: "flex", justifyContent: filters.key === "cc" ? 'space-between' : 'flex-end', width: "100%", alignItems: "center" }}>
        <Stack
          direction={'row'}
          justifyContent={filters.key === 'cc' ? 'space-between' : 'flex-end'}
          alignItems={'center'}
          gap={2}
          my={2}
        >
          <FormControl>
            <InputLabel id="label-filter-by">Filtrar por:</InputLabel>
            <Select
              label="Filtrar por:"
              variant='outlined'
              value={filters.key}
              sx={{ backgroundColor: 'white' }}
              onChange={(e) => {
                localStorage.setItem('filterKey', e.target.value)
                setFilters({
                  ...filters,
                  key: e.target.value,
                })
              }}
            >
              <MenuItem value="cc">
                <Typography fontSize={14}>Cédula de ciudadanía</Typography>
              </MenuItem>
              <MenuItem value="onboarding_id">
                <Typography fontSize={14}>Onboarding ID</Typography>
                <Typography fontSize={14}></Typography>
              </MenuItem>
            </Select>
          </FormControl>
          {filters.key === 'cc' ? (
            <>
              <TextField
                fullWidth
                label="Número"
                variant="outlined"
                type="text"
                sx={{
                  backgroundColor: 'white',
                  maxWidth: 200,
                }}
                value={filters.userDocId}
                onChange={(e) => {
                  setFilters({
                    ...filters,
                    userDocId: e.target.value,
                  })
                }}
              />
            </>
          ) : (
            <TextField
              fullWidth
              label="Código"
              variant="outlined"
              type="text"
              sx={{
                backgroundColor: 'white',
                maxWidth: 200,
              }}
              value={filters.onboardingId}
              onChange={(e) => {
                setFilters({
                  ...filters,
                  onboardingId: e.target.value,
                })
              }}
            />
            )
          }
          <Button
            variant="contained"
            color="primary"
            size="large"
            onClick={() => {
              const copyFilters = JSON.parse(JSON.stringify(filters))
              if (copyFilters.key === 'cc') {
                copyFilters.userDocType = copyFilters.key.toUpperCase()
                delete copyFilters.selectedOnboarding
                delete copyFilters.onboardingId
                delete copyFilters.value
                delete copyFilters.key
                delete copyFilters.selectedOnboarding
              } else {
                console.log('copyFilters', copyFilters)
                delete copyFilters.country
                delete copyFilters.userDocId
                delete copyFilters.userDocType
                delete copyFilters.value
                delete copyFilters.key
                delete copyFilters.selectedOnboarding
              }

              getUserInfo(copyFilters)
            }}
          >
            Buscar
          </Button>
        </Stack>
        {filters.key === 'cc' && (
          <FormControl disabled={!currentOnboardings.length}>
            <InputLabel id="label-onboarding-select">Selecciona la solicitud:</InputLabel>
            <Select
              id="onboarding-select"
              label="Selecciona la solicitud:"
              variant='outlined'
              value={filters.selectedOnboarding}
              sx={{ backgroundColor: 'white' }}
              onChange={(e) => {
                startLoading()
                const timer = setTimeout(() => {
                  stopLoading()
                  setFilters({
                    ...filters,
                    selectedOnboarding: e.target.value,
                  })
                  clearTimeout(timer)
                }, 1000)
              }}
            >
              <MenuItem value="default" style={{ flexDirection: "column", alignItems: "flex-start" }}>
                <Typography fontSize={16}>No hay solicitud seleccionada</Typography>
                <Typography fontSize={14}></Typography>
              </MenuItem>
              {currentOnboardings.map((onboarding: any) => (
                <MenuItem onClick={() => onSelectOnBoardingSchedule(onboarding)} key={onboarding.onboardingInfo.onboardingId} value={onboarding.onboardingInfo.onboardingId} style={{ flexDirection: "column", alignItems: "flex-start" }}>
                  <Typography fontSize={16}><strong>Fecha: {format(new Date(onboarding.onboardingInfo.creationDate), 'dd/MM/yy hh:mm:ss a')}</strong></Typography>
                  <Typography fontSize={14}>{onboarding.onboardingInfo.onboardingId}</Typography>
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        )}
      </div>
      <BoxWithShadow>
        {!kpUser ? (
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              p: 4,
              alignItems: 'center',
            }}
          >
            {/* <img src={DummySelfie} alt="Dummy Selfie" /> */}
            <Typography variant="h6">No se encontraron resultados</Typography>
            <Typography variant="body1">
              Realiza una búsqueda para ver la información de un usuario
            </Typography>
          </Box>
        ) : (
          <>
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                p: 4,
              }}
            >
              <Stack
                direction="row"
                spacing={1}
                justifyContent={'space-between'}
                alignItems={'center'}
              >
                <Typography variant="h5">
                  <strong>{kpUser?.clientInfo.firstName}{' '}
                  {kpUser?.clientInfo.lastName}</strong>
                </Typography>
                {/* <img src={FlagColombiaIcon} alt="Colombia flag" width={40} />
                <Typography variant="body1">
                  {kpUser?.clientInfo.country === 'CO' ? 'Colombia' : ''}
                </Typography> */}
                <Stack direction="row" spacing={1} alignItems={'center'}>
                  <FontAwesomeIcon icon={faKey} />
                  <Typography
                    minWidth={100}
                    fontWeight={'500'}
                    variant="body1"
                  >
                    Onboarding ID
                  </Typography>
                  <Typography variant="body1">
                    {kpUser?.onboardingInfo.onboardingId}
                  </Typography>
                </Stack>
              </Stack>
              <Divider sx={{ my: 4 }} />
              <Stack direction="row" spacing={1} alignItems={'flex-start'}>
                <Stack flex={1} direction="column" spacing={1}>
                  <Stack direction="row" spacing={1} alignItems={'center'}>
                    <FontAwesomeIcon icon={faIdCard} />
                    <Typography
                      minWidth={100}
                      fontWeight={'500'}
                      variant="body1"
                    >
                      Cédula
                    </Typography>
                    <Typography variant="body1">
                      {kpUser?.clientInfo.clientDocType} {kpUser?.clientInfo.clientDocId}
                    </Typography>
                  </Stack>
                  <Stack direction="row" spacing={1} alignItems={'center'}>
                    <FontAwesomeIcon icon={faMailBulk} />
                    <Typography
                      minWidth={100}
                      fontWeight={'500'}
                      variant="body1"
                    >
                      Correo
                    </Typography>
                    <Typography variant="body1">
                      {kpUser?.clientInfo.email}
                    </Typography>
                  </Stack>
                  <Stack direction="row" spacing={1} alignItems={'center'}>
                    <FontAwesomeIcon icon={faPhone} />
                    <Typography
                      minWidth={100}
                      fontWeight={'500'}
                      variant="body1"
                    >
                      Celular
                    </Typography>
                    <Typography variant="body1">
                      {kpUser?.clientInfo.phone}
                    </Typography>
                  </Stack>
                  <Stack direction="row" spacing={1} alignItems={'center'}>
                    <FontAwesomeIcon icon={faClock} />
                    <Typography
                      minWidth={100}
                      fontWeight={'500'}
                      variant="body1"
                    >
                      Fecha de expedición
                    </Typography>
                    <Typography variant="body1">
                      {kpUser?.clientInfo.issueDate ? format(
                        new Date(kpUser?.clientInfo.issueDate),
                        'dd/MM/yy',
                      ) : ""}
                    </Typography>
                  </Stack>
                </Stack>
                <Stack flex={1} direction="column" spacing={1}>
                  <Stack
                    flex={1}
                    direction="row"
                    spacing={1}
                    alignItems={'center'}
                  >
                    <FontAwesomeIcon icon={faClock} />
                    <Typography
                      minWidth={100}
                      fontWeight={'500'}
                      variant="body1"
                    >
                      Fecha de creación
                    </Typography>
                    <Typography variant="body1">
                      {kpUser?.onboardingInfo?.creationDate
                        ? format(
                          new Date(kpUser.onboardingInfo.creationDate),
                          'dd/MM/yy hh:mm:ss a',
                        )
                        : ''}
                    </Typography>
                  </Stack>
                  <Stack
                    flex={1}
                    direction="row"
                    spacing={1}
                    alignItems={'center'}
                  >
                    <FontAwesomeIcon icon={faDollarSign} />
                    <Typography
                      minWidth={100}
                      fontWeight={'500'}
                      variant="body1"
                    >
                      {kpUser?.resultsModel?.creditLimit ? 'Cupo preaprovado' : 'Sin cupo preaprovado'}
                    </Typography>
                    <Typography variant="body1">
                      {kpUser?.resultsModel?.creditLimit ? formatToCOP(Number(kpUser?.resultsModel?.creditLimit)) : ""}
                    </Typography>
                  </Stack>
                </Stack>
              </Stack>
              <Divider sx={{ my: 4 }} />
              <Stack direction="row" spacing={1} alignItems={'center'} mb={2}>
                <FontAwesomeIcon icon={faUser} />
                <Typography variant="h6">Datos opcionales del usuario</Typography>
              </Stack>
              {/* Data extracted from the user's photos */}
              <Stack direction="row" spacing={1} alignItems={'center'}>
                <Stack flex={1} direction="row" spacing={1}>
                  <Stack direction="column" spacing={1} flex={1}>
                    <Stack direction="row" spacing={1} alignItems={'center'}>
                      <Typography
                        minWidth={100}
                        fontWeight={'500'}
                        variant="body1"
                      >
                        Estatura
                      </Typography>
                      <Typography variant="body1">
                        {kpUser?.clientInfo.height}
                      </Typography>
                    </Stack>
                    <Stack direction="row" spacing={1} alignItems={'center'}>
                      <Typography
                        minWidth={100}
                        fontWeight={'500'}
                        variant="body1"
                      >
                        Situación de empleado
                      </Typography>
                      <Typography variant="body1">
                        {kpUser?.clientInfo.employmentSituation}
                      </Typography>
                    </Stack>
                  </Stack>
                </Stack>
                <Stack direction="column" spacing={1} flex={1}>
                  <Stack direction="row" spacing={1} alignItems={'center'}>
                    <Typography
                      minWidth={100}
                      fontWeight={'500'}
                      variant="body1"
                    >
                      Fecha de nacimiento
                    </Typography>
                    <Typography variant="body1">
                      {kpUser?.clientInfo.dateOfBirth ? format(
                        new Date(kpUser?.clientInfo.dateOfBirth),
                        'dd/MM/yy',
                      ) : ""}
                    </Typography>
                  </Stack>
                  <Stack direction="row" spacing={1} alignItems={'center'}>
                    <Typography
                      minWidth={100}
                      fontWeight={'500'}
                      variant="body1"
                    >
                      Lugar de nacimiento
                    </Typography>
                    <Typography variant="body1">
                      {kpUser?.clientInfo.placeOfBirth}
                    </Typography>
                  </Stack>
                </Stack>
              </Stack>
              <Stack direction="row" spacing={1} alignItems={'center'} mt={4}>
                <Stack direction="column" spacing={1} flex={1}>
                  <Stack direction="row" spacing={1} alignItems={'center'}>
                    <Typography
                      minWidth={100}
                      fontWeight={'500'}
                      variant="body1"
                    >
                      RH
                    </Typography>
                    <Typography variant="body1">
                      {kpUser?.clientInfo.bloodType}
                    </Typography>
                  </Stack>
                  <Stack direction="row" spacing={1} alignItems={'center'}>
                    <Typography
                      minWidth={100}
                      fontWeight={'500'}
                      variant="body1"
                    >
                      Género
                    </Typography>
                    <Typography variant="body1">
                      {kpUser?.clientInfo.gender}
                    </Typography>
                  </Stack>
                </Stack>
                <Stack direction="column" spacing={1} flex={1}>
                  <Stack direction="row" spacing={1} alignItems={'center'}>
                    <Typography
                      minWidth={100}
                      fontWeight={'500'}
                      variant="body1"
                    >
                      Estado financiero
                    </Typography>
                    <Typography variant="body1">
                      {kpUser?.clientInfo.employmentSituation}
                    </Typography>
                  </Stack>
                  <Stack direction="row" spacing={1} alignItems={'center'}>
                    <Typography
                      minWidth={100}
                      fontWeight={'500'}
                      variant="body1"
                    >
                      Ingresos mensuales
                    </Typography>
                    <Typography variant="body1">
                      {kpUser?.clientInfo.monthlyIncome}
                    </Typography>
                  </Stack>
                </Stack>
              </Stack>
              {/* Photos success of flow user */}
              <Divider sx={{ my: 4 }} />
              <Typography mb={2} variant="h6">
                Fotos
              </Typography>
              <Stack direction={'row'} flex={1} spacing={2}>
                {kpUser?.files.map((item: any, index: any) => (
                  <div
                    onClick={() => onPreviewImg(item.filePath)}
                    key={index}
                  >
                    <BoxPicture>
                      <img
                        src={item.filePath}
                        alt="Selfie"
                        width={50}
                        height={50}
                        style={{
                          objectFit: 'cover',
                        }}
                      />
                      <Box
                        sx={{
                          display: 'flex',
                          flexDirection: 'column',
                        }}
                      >
                        <Typography variant="body1" fontWeight={'600'}>
                          {item.label}
                        </Typography>
                      </Box>
                    </BoxPicture>
                  </div>
                ))}
              </Stack>
              {/* Contracts of user */}
              <Divider sx={{ my: 4 }} />
              <Typography mb={2} variant="h6">
                Documentos
              </Typography>
              <Stack direction={'row'} flex={1} spacing={2}>
                {/* no contract yet */}
                <Typography variant="body1">No hay documentos</Typography>
              </Stack>
              {/* Terms and conditions */}
              <Divider sx={{ my: 4 }} />
              <Typography mb={2} variant="h6">
                Términos y condiciones
              </Typography>
              <Stack direction={'row'} flex={1} spacing={2}>
                {kpUser?.termsAndConditions.map((item: any, index: any) => (
                  <Link
                    key={index}
                    to={item.termPath}
                    target="_blank"
                    style={{
                      textDecoration: 'none',
                    }}
                  >
                    <BoxPicture>
                      <FontAwesomeIcon
                        icon={faUnlock}
                        style={{
                          marginLeft: 10,
                        }}
                      />
                      <Box
                        sx={{
                          display: 'flex',
                          flexDirection: 'column',
                        }}
                      >
                        <Typography variant="body1" fontWeight={'600'}>
                          {item.termAndConditionName}
                        </Typography>
                        <Typography
                          variant="body2"
                          sx={{
                            color: 'green',
                            fontWeight: 'bold',
                          }}
                        >
                          Aceptados
                        </Typography>
                      </Box>
                    </BoxPicture>
                  </Link>
                ))}
              </Stack>
            </Box>
          </>
        )}
      </BoxWithShadow>
      {/* Modal */}
      <ModalImage imageUrl={selectedImage ?? ''} onClose={handleCloseModal} />
      {previewImg && (
        <>
          <div className="overlay-preview" onClick={() => setPreviewImg("")}></div>
          <div className="modal-preview">
            <div className="modal-preview-content">
              <img src={previewImg || ""} alt="Preview" />
            </div>
          </div>
        </>
      )}
    </Container>
  )
}

export default ClientSheet
